var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn manage-staffing-page-container" },
    [
      _c("div", { staticClass: "container-fluid search-session bg-white" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-sm-6" },
            [
              _c(
                "b-input-group",
                [
                  _c("b-form-input", {
                    staticClass: "placeholder-italic",
                    attrs: {
                      type: "text",
                      placeholder: "Search by staff name",
                      formatter: _vm.format
                    },
                    model: {
                      value: _vm.keyword,
                      callback: function($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "search-icon" })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 col-sm-6 text-right" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "staffing-table" }, [
        _vm.staffList.length !== 0
          ? _c(
              "div",
              { staticClass: "table-title" },
              [
                _c("StaffingHeader", {
                  attrs: { pagingObj: _vm.pagingObj },
                  on: { CHANGE_PAGING_OPTIONS: _vm.changePagingOptions }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "loading-staffing",
            class: { isLoading: _vm.getLoading, noDisplay: !_vm.getLoading }
          },
          [
            _c("Icon", {
              staticClass: "icon-size",
              attrs: { name: "spinner", scale: "5", pulse: "" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "dt-body" } },
          [
            _vm._l(_vm.staffList, function(item, index) {
              return _c("StaffingRow", {
                key: item,
                staticClass: "event-row-wrapper",
                attrs: { item: item, index: index },
                on: { getListStaff: _vm.getAllStaff }
              })
            }),
            _vm._v(" "),
            _c(
              "infinite-loading",
              {
                ref: "infiniteLoading",
                attrs: { distance: 100 },
                on: { infinite: _vm.infiniteHandler }
              },
              [
                _c("Spinner", { attrs: { slot: "spinner" }, slot: "spinner" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "infinite-status-prompt",
                  attrs: { slot: "no-more" },
                  slot: "no-more"
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "infinite-status-prompt",
                  attrs: { slot: "no-results" },
                  slot: "no-results"
                })
              ],
              1
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("ScrollTop"),
      _vm._v(" "),
      _c("StaffDetailModal", { attrs: { staffDetail: _vm.item } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33a5df18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a5df18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/staffing/StaffingSection.vue
// module id = 2098
// module chunks = 1